import React from "react";
import Navbar from "../components/Navbar";
import Cover from "../components/Cover";
import styles from "../styles/Projects.module.css";
import ImageGrid from "../components/ImageGrid";
import Copyright from "../components/Copyright";

const Projects: React.FC = () => {
    const imagePaths = [
        './grid-1.png',
        './grid-2.png',
        './grid-3.png',
        './grid-4.png',
    ];
    return (
        <div className={styles.coverContainer}>
        <Navbar />
        <Cover imagePath="./first-cover2.png" textOnImage="Split Heritage" />
        <p className={styles.title}>Our Projects</p>
        <div className={styles.textContainerPage}>
            <p className={styles.text}>
                Split Heritage strives to:
                <br></br>
                <br></br>
                - To ensure projects that maintain and restore works of art and traditions of Split culture. The activity of the organization is aimed at securing the future for many historical works of art that are in immediate danger from environmental and economic harmful factors affecting the City.
                <br></br>
                <br></br>
                - Encourage cooperation and discussion among other organizations involved in similar efforts around the world, to ensure that we do our best for the City and the Republic of Croatia using the most modern resources.
                <br></br>
                <br></br>
                <ImageGrid images={imagePaths} />
                - Provide exhibitions, lectures and performances in museums, libraries, theaters and universities in order to continue to promote the goals and efforts of the organization, as well as love and respect for the cultural heritage of the City of Split.
                <br></br>
                <br></br>
                - We accept the great responsibility of F. Dostoevsky "Beauty Will Save the World"
                <br></br>
                <br></br>
                - We owe all this to the city, which has been under UNESCO protection since October 26, 1979, which is a unique example in the world.
            </p>
            <Copyright />
        </div>
        </div>
    );
}

export default Projects;